
import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ErrorStateMatcher } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';
import { DefaultErrorStateMatcher } from '../validation/DefaultErrorStateMatcher';

@Component({
    selector: 'cerrix-input-numeric',
    imports: [
    ErrorMessagesPipe,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
],
    templateUrl: './cerrix-input-numeric.component.html',
    styleUrl: './cerrix-input-numeric.component.scss',
    providers: []
})
export class CerrixInputNumericComponent implements ControlValueAccessor {
  @Input() public value: number | undefined = undefined;
  @Input() public placeholder: string = '';
  @Input() public disabled: boolean = false;

  @Input() public minValue: number | null = null;
  @Input() public maxValue: number | null = null;

  @Input() public usedecimal: boolean = false;
  @Input() public dataUiid: string = "undefined"
  

  @ViewChild('numericInput') protected inputRef: ElementRef | undefined;

  protected errorMatcher!: ErrorStateMatcher;
  protected ngControl = inject(NgControl, { optional: true, self: true });

  private onValueChange = (value: number | undefined) => {};
  private onTouched = () => {};

  public writeValue(value: number): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: number | undefined) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
      this.errorMatcher = new DefaultErrorStateMatcher();
    }
  }

  protected onChange(event: Event) {
    const restrictRegEx = this.usedecimal ? /[^0-9-.]/g : /[^0-9-]/g;
    const inputStringValue = (event.target as HTMLInputElement)?.value;

    this.value = inputStringValue?.replace(
      restrictRegEx,
      ''
    ) as unknown as number;

    this.onValueChange(this.value);

    if (this.value?.toString() !== inputStringValue) {
      if (this.inputRef?.nativeElement) {
        this.inputRef.nativeElement.value = this.value?.toString();
      }
      this.ngControl?.control?.patchValue(this.value, { emitEvent: true });
    }
  }

  protected onKeydown(event: KeyboardEvent) {
    if (
      (!this.usedecimal && event.key === '.') ||
      event.key === 'e' ||
      event.key === 'E'
    ) {
      return false;
    }

    return true;
  }
}
